import React, { ReactElement } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { TopologiesLayout } from '../../layouts/TopologiesLayout';
import { HelpButton } from '../../components/HelpButton';
import { CREATE_TOPOLOGY_HELP_LINKS } from '../../constants/user-guide';
import { CreateTopologyRoutes } from './constants';
import { useCreateTopology } from './hooks/use-create-topology';
import { WizardSteps } from './components/WizardSteps';
import { NoDataCenterRedirectRoute } from './components/NoDataCenterRedirectRoute';
import { Details } from './pages/Details';
import { DataCenters } from './pages/DataCenters';
import { DemoImportContainer } from './pages/DemoImport/container';
import { CreateTopologyProps } from './container';
import { ConnectedDemoTemplate } from './pages/DemoTemplate/container';
import { DemoType } from './pages/DemoType';
import { DEMO_TYPES } from './pages/DemoType/constants';

export function CreateTopology({
  isLoading,
  datacenters,
}: CreateTopologyProps): ReactElement {
  const { path } = useRouteMatch();

  const {
    creating,
    demoType,
    demoToImport,
    templateToImport,
    datacenter,
    onCreate,
    setDatacenter,
    setDemoType,
    setDemoToImport,
    setTemplateToImport,
  } = useCreateTopology();

  return (
    <TopologiesLayout showLoadingSpinner={isLoading}>
      <div className="container">
        <WizardSteps dataCenter={datacenter} demoType={demoType} />
        <Switch>
          <Route
            path={path}
            render={() => (
              <DataCenters
                setDataCenter={setDatacenter}
                resetDemoType={() => setDemoType('')}
                datacenters={datacenters || []}
              />
            )}
            exact={true}
          />
          <NoDataCenterRedirectRoute
            datacenter={datacenter}
            path={`${path}${CreateTopologyRoutes.DemoType}`}
            render={() => (
              <DemoType
                setDemoType={setDemoType}
                resetDemoToImport={() => setDemoToImport(undefined)}
                demoTypes={DEMO_TYPES}
              />
            )}
            exact={true}
          />
          <NoDataCenterRedirectRoute
            datacenter={datacenter}
            path={`${path}${CreateTopologyRoutes.Details}`}
            render={() => (
              <Details
                onSubmit={onCreate}
                submitting={creating}
                demoToImport={demoToImport}
                templateToImport={templateToImport}
                demoType={demoType}
              />
            )}
            exact={true}
          />
          <NoDataCenterRedirectRoute
            datacenter={datacenter}
            path={`${path}${CreateTopologyRoutes.DemoImport}`}
            render={() => (
              <DemoImportContainer
                setDemoToImport={setDemoToImport}
                datacenter={datacenter as DataCenter}
              />
            )}
            exact={true}
          />
          <NoDataCenterRedirectRoute
            datacenter={datacenter}
            path={`${path}${CreateTopologyRoutes.DemoTemplate}`}
            render={() => (
              <ConnectedDemoTemplate
                datacenter={datacenter as DataCenter}
                setTemplateToImport={setTemplateToImport}
              />
            )}
            exact={true}
          />
        </Switch>
      </div>
      <HelpButton links={CREATE_TOPOLOGY_HELP_LINKS} />
    </TopologiesLayout>
  );
}
